import {ColorCircles} from "./ChannelDropdown";
import ScaleToFit from './ScaleToFit';
import O from './O';

//<div style={{color:'magenta'}} class="absolute-cover"> <O>{{resolvedWidth,resolvedHeight}}</O> </div>

export default function MissingChannel({nodeId,value,width,height}){

  let colors = Object.values(value?.layersByChannelId||{}).map(x => x.color)


  return (

    <div nodeId={nodeId} style={{
      fontSize:width/6,
      //border:'3px solid white',
      background:'#ccc',
      textAlign:'center',
      alignText:'center',
        height,
        width,
      
    }} class="absolute-cover sg-col h-center v-center rel">
        <div>MISSING</div>
        <div class="sg-row h-center">
          <ColorCircles selectedSize={height/4} colors={colors}/>
      </div>
        <div>CHANNEL</div>

        </div>
  )
}
